import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { signUpWithOauth } from 'components/views/logged_out/SignUp/Helpers'
import ScAnalytics, { actions } from 'classes/sc_analytics'
import AuthHelper from 'helpers/auth_helper'
import ErrorsHelper from 'helpers/errors_helper'
import { modalEnum } from 'components/modals/v2/modal'
import ImageUploadHelpers from 'helpers/image_upload_helpers'
import { useModalContext, useRootContext } from 'hooks/use_context'

const useOauthSignup = (setError) => {
  const rootContext = useRootContext()
  const modalContext = useModalContext()
  const dispatch = useDispatch()

  const _sendEvent = useCallback((oauth) => {
    ScAnalytics.sendMetric(actions.userCreateFunnel.generalInfo, {
      signup_divided_steps_flow: true,
      ...(oauth && { oauth }),
    })
  }, [])

  const _handleLogin = useCallback(
    (oauth) => {
      AuthHelper.performLogin(
        { ...oauth, client: 'desktop' },
        async () => {
          rootContext.setLoading(false)
          modalContext.onCloseModal()
          await rootContext.onAuthSuccess()
          AuthHelper.performLoginRedirect()
        },
        (e) => {
          rootContext.setLoading(false)
          const error = ErrorsHelper.normalizeError(e)
          setError(error || 'An error occurred during sign up. Please try again.')
        }
      )
    },
    [modalContext.onCloseModal, rootContext.setLoading, rootContext.onAuthSuccess]
  )

  const _handleSignUp = useCallback(async (oauth) => {
    const { google_token_id, instagram_auth_code } = oauth
    const signUp = await signUpWithOauth({}, { google_token_id, instagram_auth_code })
    return signUp
  }, [])

  const onOauthSignUp = useCallback(
    async (oauth) => {
      rootContext.setLoading(true)
      const signUp = await _handleSignUp(oauth)

      const emailTaken = signUp.message === ErrorsHelper.user.emailTaken
      if (emailTaken) return _handleLogin(oauth)
      if (signUp.error) return setError(signUp.message)

      await ImageUploadHelpers.uploadImageFromGoogle(oauth.google_token_id)
      _sendEvent('google')
      await rootContext.onAuthSuccess()
      AuthHelper.performLoginRedirect()
      rootContext.setLoading(false)
      modalContext.onOpenModal(modalEnum.signUpAdditionalDetails)
    },
    [dispatch, modalContext.onOpenModal, _sendEvent, setError, _handleLogin, rootContext.onAuthSuccess]
  )

  return onOauthSignUp
}

export default useOauthSignup
